module.exports = __webpack_public_path__ + "static/media/tally.e6292c58.svg";